import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Switch } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { FeedbackService } from '~/service/service.feedback';
import { FeedbackReplyDto } from '~/shared/dto/admin/feedback.dto';
import { Form } from '~/shared/form';
import { useService } from '~/shared/service/service.base';
import { FieldNumber } from '~/view/fields/field.number';
import { FieldText } from '~/view/fields/field.text';
import { AsyncView } from '../view.async';
import { Col, Row, Text } from '../view.box';

export const FeedbackReplyDialog = observer(() => {
	const [{ replyDialogVisible, getLastReply, hideReplyDialog, replyToSelected, async, selectedItem }] =
		useService(FeedbackService);

	const form = Form.use(FeedbackReplyDto, {
		name: 'FeedbackReplyDto',
		onSubmit: replyToSelected,
	});

	useEffect(() => {
		form.reset();
		form.apply(getLastReply() ?? {});
	}, [form, getLastReply, selectedItem]);

	return (
		<Dialog open={replyDialogVisible} PaperProps={{ sx: { p: 2, width: 400 } }}>
			<AsyncView async={async}>
				<DialogTitle>
					<Row justifyContent="space-between">
						<Text>Reply to feedback</Text>
						<IconButton onClick={hideReplyDialog}>
							<Close />
						</IconButton>
					</Row>
				</DialogTitle>
				<DialogContent>
					<Col gap={2}>
						<FieldText field={form.$title} />
						<FieldText multiline field={form.$message} />
						<FieldText multiline field={form.$description} />
						<FieldText field={form.$analyticsLabel} />
						<FieldText field={form.$imgLeft} />
						<FieldText field={form.$imgRight} />
						<FieldNumber field={form.$fragranceId} />
						<Row>
							<Switch
								checked={!!form.$status.value}
								onChange={e => form.$status.set(e.target.checked ? 'DONE' : undefined)}
							/>
							Mark feedback as RESOLVED
						</Row>
					</Col>
				</DialogContent>
				<DialogActions>
					<Button onClick={hideReplyDialog}>Cancel</Button>
					<Button variant="contained" onClick={form.submit}>
						Send
					</Button>
				</DialogActions>
			</AsyncView>
		</Dialog>
	);
});
